module.exports = __webpack_public_path__ + "img/SR_ICON_Energie.34714a18.svg";